import React from 'react';
import ModalDefault from 'v2/components/ModalDefault';
import { IModalCommandSuggestions } from './types';
import useModalCommandSuggestions from './hooks/useModalCommandSuggestions';
import * as SC from './styles';
import Icon from 'v2/components/Icon';
const ModalCommandSuggestions: React.FC<IModalCommandSuggestions> = ({
  isOpen,
  stepCurrent,
  onBack,
  onClose,
  setPrompt,
  setStepCurrent,
}) => {
  const { steps, handelSetPrompt } = useModalCommandSuggestions({
    setPrompt,
    onClose,
  });
  return (
    <ModalDefault
      title="SUGESTÕES DE COMANDOS"
      iconName="TipsAndUpdatesOutlined"
      isOpen={isOpen}
      onBack={onBack}
      onClose={onClose}
    >
      <SC.Container>
        <SC.Header>
          {steps.map((item) => (
            <SC.Button
              key={item.id}
              isCurrent={stepCurrent === item.id}
              onClick={() => setStepCurrent(item.id)}
            >
              {stepCurrent === item.id && <SC.Circle />}
              {item.title}
            </SC.Button>
          ))}
        </SC.Header>

        <SC.Content>
          {steps[stepCurrent].options.map((item) => (
            <SC.Option
              key={item.id}
              onClick={() => handelSetPrompt(item.title)}
            >
              {item.title}
              <Icon
                htmlColor="#fff"
                fontSize="small"
                iconName="ArrowForwardIosOutlined"
              />
            </SC.Option>
          ))}
        </SC.Content>
      </SC.Container>
    </ModalDefault>
  );
};

export default ModalCommandSuggestions;
